import { useSelector } from 'react-redux';

const useGetHealthPlan = () => {
    return useSelector((state) => state.healthPlan.healthPlan);
};

export default useGetHealthPlan;